<template>
  <div>
    <div class="main-content">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="col-md-12">
                  <ValidationObserver ref="formObserver" v-slot="{ invalid, validate }">
                    <b-form @submit.prevent="handleSubmit(validate)">
                      <div class="form-row">
                        <div class="form-group col-md-6">
                          <ValidationProvider name="Title" rules="required" v-slot="{ errors }">
                            <label for="Name">
                              <span class="required">*</span> {{ $t('Name') }}:
                            </label>
                            <b-form-input
                                id="Name"
                                type="text"
                                v-model="landmark.destino_nome"
                                :state="errors.length ? false : null"
                                placeholder=""
                            />
                            <b-form-invalid-feedback :state="errors.length">{{
                                $t(errors[0])
                              }}
                            </b-form-invalid-feedback>
                          </ValidationProvider>
                        </div>
                        <div class="form-group col-md-6">
                            <label for="Address">
                              {{ $t('Address') }}:
                            </label>
                            <b-form-input
                                id="Address"
                                type="text"
                                v-model="landmark.destino_endereco"
                                placeholder=""
                            />
                        </div>
                        <div class="form-group col-md-4">
                            <label for="Latitude">
                              {{ $t('Latitude') }}:
                            </label>
                            <b-form-input
                                id="Latitude"
                                type="text"
                                v-model="landmark.destino_lat"
                                placeholder=""
                            />
                        </div>
                        <div class="form-group col-md-4">
                            <label for="Longitude">
                              {{ $t('Longitude') }}:
                            </label>
                            <b-form-input
                                id="Longitude"
                                type="text"
                                v-model="landmark.destino_long"
                                placeholder=""
                            />
                        </div>
                        <div class="form-group col-md-4">
                            <label for="Telefone">
                              {{ $t('Telefone') }}:
                            </label>
                            <b-form-input
                                id="Telefone"
                                type="text"
                                v-model="landmark.destino_telefone"
                                v-mask="'(##) #####-####'" placeholder="(00) 00000-0000"
                            />
                        </div>
                        <div class="form-group col-md-3">
                          <ValidationProvider name="Type Of Professional" rules="required" v-slot="{ errors }">
                            <label for="professionalTypeId"><span class="required">*</span>{{
                                $t('Type Of Landmark')
                              }}:</label>
                            <v-select
                                :options="landmark_types"
                                :reduce="(landmark_types) => landmark_types.id"
                                :label="'name'"
                                v-model="landmark.tipo_destino_id"
                                class="vselect"
                                :class="{ 'is-invalid': errors.length }"
                            />
                            <span class="invalid-feedback">{{ $t(errors[0]) }}</span>
                          </ValidationProvider>
                        </div>
                        <div class="form-group col-md-3">
                          <ValidationProvider name="Status" rules="required" v-slot="{ errors }">
                            <label for="status">
                              <span class="required">*</span> {{ $t('Status') }}:
                            </label>
                            <b-form-select
                                id="Status"
                                v-model="landmark.destino_situacao"
                                :state="errors.length ? false : null"
                            >
                              <option value="1"> {{ $t('Active') }}</option>
                              <option value="0"> {{ $t('Inactive') }}</option>
                            </b-form-select>
                            <b-form-invalid-feedback :state="errors.length">{{
                                $t(errors[0])
                              }}
                            </b-form-invalid-feedback>
                          </ValidationProvider>
                        </div>
                        </div>
                          <span class="required_fields">
                          <span class="required">*</span>
                             <strong>{{ $t('Required Fields') }}</strong>
                          </span>
                          <div class="block text-right">
                            <b-button variant="outline-secondary" class="btn btn-back" @click="$router.go(-1)">
                              <i class="fa fa-arrow-left"></i> {{ $t('To Go Back') }}
                            </b-button>

                            <b-button type="submit" variant="primary" class="ml-1">
                              {{ $t('Save') }}
                              <i class="fa fa-save"></i>
                            </b-button>
                        </div>
                    </b-form>
                  </ValidationObserver>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {ValidationObserver, ValidationProvider, extend} from "vee-validate";
import {required} from "vee-validate/dist/rules";
import {
  BForm,
  BFormGroup,
  BFormInput,
  BFormInvalidFeedback,
  BButton, BFormSelect,
} from "bootstrap-vue";
import axios from "axios";
import vSelect from 'vue-select';

extend("required", required);

export default {
  data() {
    return {
      landmark: {
        destino_nome: "",
        destino_situacao: "",
        destino_endereco: "",
        destino_lat: "",
        destino_long: "",
        destino_telefone: "",
        tipo_destino_id: ""
      },
      landmark_types: [],
      errors: undefined,
      previewImage: null,
    };
  },
  computed: {},
  methods: {
    async handleSubmit(validate) {
      const isValid = await validate();
      if (isValid) {
        this.save();
      }
    },
    save() {
      const self = this;
      let api = self.$store.state.api + "landmarks";

      if (self.landmark.id) {
        self.landmark._method = "PUT";
        api += "/" + self.landmark.destino_id;
      }

      axios
          .post(api, self.landmark)
          .then(() => {
            self.$message(
                this.$t("Success"),
                this.$t("Landmark saved successfully"),
                "success"
            );
            self.$router.push("/landmarks");
          })
          .catch((error) => {
            self.$error(error);
          });
    },
    getLandmarks(id) {
      let api = this.$store.state.api + "landmarks/" + id;

      axios
          .get(api)
          .then((response) => {
            this.landmark = response.data.data[0];
          })
          .catch((error) => {
            this.$error(error);
          });
    },
    getLandmarkTypes() {
      let api = this.$store.state.api + "landmark_types?paginated=false";
      axios
          .get(api)
          .then((response) => {
            this.landmark_types = response.data.data;
          })
          .catch((error) => {
            this.$error(error);
          });
    },
  },
  mounted() {
    const self = this;
    let id = self.$route.params.id;

    self.getLandmarkTypes();

    if (id) {
      self.getLandmarks(id);
    }
  },
  components: {
    BFormSelect,
    vSelect,
    ValidationObserver,
    ValidationProvider,
    BForm,
    BFormGroup,
    BFormInput,
    BFormInvalidFeedback,
    BButton,
  },
};
</script>
